export function Logo({ onClick }) {
  return (
    <button
      type="button"
      onClick={onClick}
      data-testid="logo-home-link"
      className="flex items-center gap-2.5 text-left"
    >
      <svg width="36" height="36" viewBox="0 0 64 64" aria-hidden="true">
        <rect width="64" height="64" rx="14" fill="#F59E0B" />
        <path d="M34 8 L18 36 h11 L28 56 L46 26 h-11 z" fill="#0B0F17" />
      </svg>
      <span className="font-display leading-none">
        <span className="block text-lg font-extrabold tracking-tight text-white">
          SOS RIPARAZIONI
        </span>
        <span className="mt-1 block text-[10px] font-mono uppercase tracking-[0.3em] text-amber-400">
          24 · Pronto Intervento
        </span>
      </span>
    </button>
  );
}
